var map = {
	"./abanca/environment.dev": 653,
	"./abanca/environment.dev.ts": 653,
	"./abanca/environment.local": 7691,
	"./abanca/environment.local.ts": 7691,
	"./abanca/environment.stage": 8569,
	"./abanca/environment.stage.ts": 8569,
	"./abanca/environment.ts": 1702,
	"./banorte/environment.dev": 5738,
	"./banorte/environment.dev.ts": 5738,
	"./banorte/environment.local": 8925,
	"./banorte/environment.local.ts": 8925,
	"./banorte/environment.stage": 7378,
	"./banorte/environment.stage.ts": 7378,
	"./banorte/environment.ts": 5235,
	"./esgsan-web-abanca-dev/environment.dev": 5686,
	"./esgsan-web-abanca-dev/environment.dev.ts": 5686,
	"./esgsan-web-abanca-dev/environment.local": 6946,
	"./esgsan-web-abanca-dev/environment.local.ts": 6946,
	"./esgsan-web-abanca-dev/environment.stage": 5865,
	"./esgsan-web-abanca-dev/environment.stage.ts": 5865,
	"./esgsan-web-abanca-dev/environment.ts": 2912,
	"./esgsan-web-santander-dev/environment.dev": 7999,
	"./esgsan-web-santander-dev/environment.dev.ts": 7999,
	"./esgsan-web-santander-dev/environment.local": 7357,
	"./esgsan-web-santander-dev/environment.local.ts": 7357,
	"./esgsan-web-santander-dev/environment.stage": 3798,
	"./esgsan-web-santander-dev/environment.stage.ts": 3798,
	"./esgsan-web-santander-dev/environment.ts": 3056,
	"./gcc/environment.dev": 5700,
	"./gcc/environment.dev.ts": 5700,
	"./gcc/environment.local": 2880,
	"./gcc/environment.local.ts": 2880,
	"./gcc/environment.stage": 7074,
	"./gcc/environment.stage.ts": 7074,
	"./gcc/environment.ts": 3572,
	"./santander/environment.dev": 3718,
	"./santander/environment.dev.ts": 3718,
	"./santander/environment.local": 238,
	"./santander/environment.local.ts": 238,
	"./santander/environment.stage": 1497,
	"./santander/environment.stage.ts": 1497,
	"./santander/environment.ts": 2395
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1983;